module.exports = __webpack_public_path__ + "static/media/rating.c71b0237.svg";